<template>
  <div class="page-loader page-loader-logo">
    <img src="/media/svg/logos/logo.svg" style="height: 40px" alt="Kema" />

    <div class="spinner spinner-primary"></div>
  </div>
</template>

<script>
import { REMOVE_BODY_CLASSNAME } from "@/store/htmlclass.module.js";

export default {
  name: "Loader",
  mounted() {
    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
  },
};
</script>
